// Central content config for SPMS Global. Edit here to update the whole site.

export const COMPANY = {
  name: "SPMS Global",
  legalName: "SPMS Global Limited",
  tagline: "Global Sourcing. Trusted Supply. Seamless Trade.",
  logo:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_035dfac8-8c03-4209-8998-c754ab9897e7/artifacts/7q7etzfy_SPMS%20Logo.png",
  // Placeholders — replace with real company details.
  address: "Unit 2A, 17/F, Glenealy Tower, No. 1 Glenealy, Central, Hong Kong SAR, China",
  email: "spmsglobal@proton.me",
  emailRaw: "spmsglobal@proton.me",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Industries & Products", to: "/industries" },
  { label: "Solutions", to: "/solutions" },
  { label: "Contact Us", to: "/contact" },
];

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1724597500306-a4cbb7d1324e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMHNoaXAlMjBjb250YWluZXIlMjBnbG9iYWwlMjB0cmFkZXxlbnwwfHx8fDE3ODM0MDA1MzF8MA&ixlib=rb-4.1.0&q=85",
  handshake:
    "https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  warehouse:
    "https://images.pexels.com/photos/5156696/pexels-photo-5156696.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  inspection:
    "https://images.unsplash.com/photo-1564182842834-681b7be6de4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxxdWFsaXR5JTIwaW5zcGVjdGlvbiUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzgyOTkxNjgyfDA&ixlib=rb-4.1.0&q=85",
  portSunset:
    "https://images.unsplash.com/photo-1759272840538-ae4b07214c71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxjYXJnbyUyMGNvbnRhaW5lciUyMHRlcm1pbmFsfGVufDB8fHx8MTc4NDAxMjc1NHww&ixlib=rb-4.1.0&q=85",
  cargoShip:
    "https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMGNvbnRhaW5lciUyMHRlcm1pbmFsfGVufDB8fHx8MTc4NDAxMjc1NHww&ixlib=rb-4.1.0&q=85",
  teamMeeting:
    "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBtZWV0aW5nJTIwdGVhbXxlbnwwfHx8fDE3ODI5OTQyOTN8MA&ixlib=rb-4.1.0&q=85",
  handshakeDeal:
    "https://images.unsplash.com/photo-1577415124269-fc1140a69e91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBtZWV0aW5nJTIwdGVhbXxlbnwwfHx8fDE3ODI5OTQyOTN8MA&ixlib=rb-4.1.0&q=85",
};

// Industries we serve — sector-level coverage (icon + name only)
export const INDUSTRIES = [
  { slug: "polyurethane", name: "Polyurethane Industry", icon: "FlaskConical", products: ["Polyether Polyol", "Polyether Polymer", "TDI"] },
  { slug: "interior-home-living", name: "Interior & Home Living Industry", icon: "Sofa", products: ["Furniture", "Chandeliers", "Soft Furnishings"] },
  { slug: "kitchenware-appliances", name: "Kitchenware & Home Appliances Industry", icon: "CookingPot", products: ["Rice Cookers", "Electric Kettles", "Induction Cookers", "Infrared Cookers"] },
  { slug: "food", name: "Food Industry", icon: "Wheat", products: ["Various Food Additives"] },
  { slug: "timber-raw-materials", name: "Timber & Raw Materials Industry", icon: "TreePine" },
  { slug: "household-fmcg", name: "Household & FMCG Industry", icon: "ShoppingBasket" },
];

// Product categories shown on the homepage
export const PRODUCT_CATEGORIES = [
  {
    name: "Kitchen Appliances",
    desc: "Compact and full-size appliances for modern kitchens.",
    image:
      "https://images.pexels.com/photos/7614540/pexels-photo-7614540.jpeg",
  },
  {
    name: "Cookware",
    desc: "Everyday and premium cookware across finishes.",
    image:
      "https://images.unsplash.com/photo-1584990347193-6bebebfeaeee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjb29rd2FyZSUyMHBvdHMlMjBwYW5zJTIwc2V0fGVufDB8fHx8MTc4NjExNjcwMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Electrical Products",
    desc: "Components, fittings and wiring accessories.",
    image:
      "https://images.unsplash.com/photo-1728808668131-76d40d112271",
  },
  {
    name: "Consumer Goods",
    desc: "Retail-ready consumer and lifestyle products.",
    image:
      "https://images.unsplash.com/photo-1526057565006-20beab8dd2ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsaWZlc3R5bGUlMjBwcm9kdWN0cyUyMGludGVyaW9yfGVufDB8fHx8MTc4NDUxNTkyNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Industrial Components",
    desc: "Parts and equipment for production lines.",
    image:
      "https://images.unsplash.com/photo-1717386255773-a456c611dc4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMG1hY2hpbmUlMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzgzMjM2ODQ0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Household Products",
    desc: "Durable, high-turnover household essentials.",
    image:
      "https://images.pexels.com/photos/1366594/pexels-photo-1366594.jpeg",
  },
];

// 10 Solutions
export const SOLUTIONS = [
  { icon: "Globe2", title: "Global Sourcing", desc: "Finding reliable suppliers and suitable products based on your requirements." },
  { icon: "Ship", title: "Logistics", desc: "Managing transportation and movement of goods across locations and borders." },
  { icon: "PackageCheck", title: "Procurement & Supply", desc: "Coordinating procurement and ensuring reliable product availability." },
  { icon: "SearchCheck", title: "Quality Inspection", desc: "Inspection and quality control before goods are dispatched." },
  { icon: "FlaskConical", title: "Sampling", desc: "Product sampling, evaluation and approval before large-scale orders." },
  { icon: "Warehouse", title: "Warehousing", desc: "Secure storage and organised inventory management." },
  { icon: "FileText", title: "Billing & Documentation", desc: "Managing commercial documentation, invoicing and trade paperwork." },
  { icon: "Landmark", title: "Banking & Trade Support", desc: "Assistance with banking processes and trade-related financial documentation." },
  { icon: "Target", title: "Custom Sourcing", desc: "Finding products and suppliers according to specific client requirements." },
  { icon: "Workflow", title: "End-to-End Trade Management", desc: "Coordinating multiple stages from sourcing to final delivery." },
];

export const PROCESS = [
  { no: "01", title: "Understand", desc: "Understand the client's product and business requirements." },
  { no: "02", title: "Source", desc: "Identify suitable products and reliable suppliers." },
  { no: "03", title: "Sample", desc: "Arrange samples for evaluation and approval." },
  { no: "04", title: "Inspect", desc: "Conduct quality checks and inspection." },
  { no: "05", title: "Ship", desc: "Coordinate logistics and documentation." },
  { no: "06", title: "Deliver", desc: "Manage warehousing and final delivery requirements." },
];

export const TRUST_CARDS = [
  { icon: "Globe2", title: "Global Sourcing", desc: "A connected network to find the right products, anywhere." },
  { icon: "Truck", title: "Reliable Supply", desc: "Consistent availability and dependable delivery timelines." },
  { icon: "ShieldCheck", title: "Quality Assured", desc: "Inspection and quality control at every critical stage." },
  { icon: "Headset", title: "End-to-End Support", desc: "One partner across sourcing, trade and delivery." },
];

export const WHY_US = [
  { icon: "Network", title: "Reliable Sourcing Network", desc: "Access to vetted suppliers across multiple markets." },
  { icon: "GraduationCap", title: "Product & Industry Expertise", desc: "Deep category knowledge that de-risks your orders." },
  { icon: "BadgeCheck", title: "Quality-Focused Approach", desc: "Inspection-led processes before anything ships." },
  { icon: "MessagesSquare", title: "Transparent Communication", desc: "Clear updates and honest timelines, end to end." },
  { icon: "Layers", title: "End-to-End Trade Support", desc: "From documentation to delivery, handled for you." },
  { icon: "Handshake", title: "Long-Term Relationships", desc: "We build partnerships, not one-off transactions." },
];

export const MARQUEE_WORDS = [
  "Global Sourcing", "Logistics", "Quality Inspection", "Warehousing",
  "Procurement", "Sampling", "Trade Support", "Custom Sourcing", "Documentation",
];
